var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from "@angular/core";
export var NNService = (function () {
    function NNService() {
    }
    NNService.prototype.recognoze = function (input) {
        console.log(nn, input);
        var brainResult = nn(input);
        return this.softmax(brainResult);
    };
    NNService.prototype.softmax = function (output) {
        var maximum = output.reduce(function (p, c) {
            return p > c ? p : c;
        });
        var nominators = output.map(function (e) {
            return Math.exp(e - maximum);
        });
        var denominator = nominators.reduce(function (p, c) {
            return p + c;
        });
        var softmax = nominators.map(function (e) {
            return e / denominator;
        });
        var maxIndex = 0;
        softmax.reduce(function (p, c, i) {
            if (p < c) {
                maxIndex = i;
                return c;
            }
            else
                return p;
        });
        var result = new Array(output.length);
        for (var i = 0; i < output.length; i++) {
            result[i] = (i == maxIndex) ? 1 : 0;
        }
        return result;
    };
    NNService = __decorate([
        Injectable(), 
        __metadata('design:paramtypes', [])
    ], NNService);
    return NNService;
}());
//# sourceMappingURL=nn.service.js.map